/**
 * Tab-scoped sessionStorage key helpers for the workflow / timeline lock
 * subsystem. The key holds the `lockId` (refresh secret) so a page reload
 * can REFRESH its existing lock instead of trying to ACQUIRE a new one.
 *
 * Single source of truth for the key shape — every consumer must import
 * from here so the prefix never drifts. Used by:
 *   - useWorkflowLocking      (acquire / refresh / release / renewal)
 *   - useTimelineLock          (acquire / refresh / release / renewal)
 *   - useUnifiedEventConsumer  (owner-tab guard for incoming WS events)
 */

export const workflowLockSessionKey = (workflowId: string): string =>
  `workflow_lock_id_${workflowId}`;

export const timelineLockSessionKey = (timelineId: string): string =>
  `timeline_lock_id_${timelineId}`;
